import { Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { Field } from 'src/app/shared/detail/detail.service';
import {SelectionModel} from '@angular/cdk/collections';
import {DialogService} from "../../dialog/dialog.service";
export interface TableDialogData{
  title: string;
  dataSource: any;
  columns: Field[];
  displayedColumns: string[];
  filter: boolean;
  selectable: boolean;
}

@Component({
    selector: 'cml-table-dialog',
    templateUrl: './table-dialog.component.html',
    styleUrls: ['./table-dialog.component.scss'],
    standalone: false
})
export class TableDialogComponent {
  displayedColumns: string[];
  dataSource: any;
  filteredDataSource: any;
  columns: Field[];
  selection: any = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: TableDialogData, private dialogRef: MatDialogRef<TableDialogComponent>,
              private dialogService: DialogService) {
    this.dataSource = data.dataSource;
    this.filteredDataSource = this.dataSource;
    this.columns = data.columns;
    this.displayedColumns = data.displayedColumns;
    if(this.data.selectable)
    {
      this.selection =  new SelectionModel(true, []);
    }

  }


onValChange(type: string){
    this.filteredDataSource = type == "all" ? this.dataSource : this.dataSource.filter((x:any) => x.type === type);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.length;
    return numSelected === numRows;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource);
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  confirmBtnHandle()
  {
    if( this.data.selectable && this.selection.selected.length > 0) {
      this.dialogRef.close(this.selection.selected)
    }
    else if(this.data.selectable) {
      this.dialogService.alert({title: "Varování", detail:"Musíte vybrat alespoň jeden záznam"})
    }
    else {
      this.closeDialog()
    }
  }

  closeDialog() {
    this.dialogRef.close(true);
  }
}

